import { Modal } from "react-bootstrap";
// import { TENANT_BUCKET } from '../../common/constants'
import { BsExclamationCircleFill } from 'react-icons/bs'
import './Alert.css';


const Alert = (props) => {
    const { typeAlert, title, message } = props

    return (
        <Modal
            {...props}
            className="alertMessage"
            animation={false}
            centered
        >
            <div className="alertMessage_body">
                {title && (<Modal.Header className="alertMessage_header">{title}</Modal.Header>)}
                <Modal.Body>
                    <div className="alertMessage_content">
                        {typeAlert === 'error' && <BsExclamationCircleFill className="me-2" />} {message}
                    </div>
                </Modal.Body>
                <Modal.Footer className={`${!title && ('p-2')}`}>
                    <button  type="button" onClick={props.onHide} className="font_button color_button alertMessage_btnClose">OK</button>
                </Modal.Footer>
            </div>
        </Modal>

    );
}

export default Alert;